import { HttpParams } from '@angular/common/http';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';

@Component({
  selector: 'app-reporting-map-detail',
  standalone: true,
  imports: [MatButtonModule],
  templateUrl: './reporting-map-detail.component.html',
  styleUrl: './reporting-map-detail.component.scss'
})
export class ReportingMapDetailComponent {
  name: string = "";
  count: string = "";
  iso: string = "";
  httpParams: HttpParams = new HttpParams();

  constructor(
    private router: Router
  ) { }
  onOpenTickets(): void {
    // Start date: January 1, 2023
    let start: Date = new Date();
    start.setFullYear(2023, 0, 1); // Jan 1, 2023
    start.setHours(0, 0, 0, 0);    // 00:00:00

    // End date: today at 23:59:59
    let end: Date = new Date();
    end.setHours(23, 59, 59, 999); // today 23:59:59.999

    // Build filters
    const filtersToSave = [
      { db_key: 'pct_countrycode', value: this.iso }
    ];
    const dateRange = {
      start: start.toISOString(),
      end: end.toISOString()
    }; // or existing date range if needed
    localStorage.setItem('pTicketFilters', JSON.stringify({ filters: filtersToSave, dateRange }));

    this.router.navigate(['/pTickets/list']);
  }



}
